import {Flex} from "@mantine/core";
import {ThemedPage} from "../../components/page/ThemedPage/ThemedPage";
import {ResizeableContent} from "../../components/ResizableContent/ResizableContent";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {useCallback, useState} from "react";
import {useChat} from "../../providers/ChatProvider/ChatProvider";
import {useOtsUISelector} from "../../hooks/useOtsUISelector";
import {getChatPageChannelUrl} from "../../store/ui/chat-page/selectors";
import {setChatPageChannelUrl} from "../../store/ui/chat-page/actions";
import {useDispatch} from "react-redux";
import {ChatLayout} from "../../components/chat/ChatLayout";

export const ChatPageRoute = () => {
  return <ChatPage/>;
};

export const ChatPage = (props: NonNullable<unknown>) => {

  const {enabled, sendbird} = useChat();
  const dispatch = useDispatch();

  const channelUrl = useOtsUISelector(getChatPageChannelUrl)

  const [currentChannel, setCurrentChannel] = useState(null);

  const onSelectChannel = useCallback((channelUrl: string | undefined) => {
    dispatch(setChatPageChannelUrl(channelUrl));
  }, [dispatch])

  if (!enabled || !sendbird) {
    return <ErrorPage message="Chat Disabled"/>;
  }

  return (
    <ThemedPage>
      {(classes) => (
        <ResizeableContent>
          {(size) => (
            <Flex h={size.height} w={size.width} className={classes.container}>
              <ChatLayout
                enableLegacyChannelModules={false}
                currentChannel={currentChannel}
                setCurrentChannel={setCurrentChannel}
              />
              {/*<div className="sendbird-app__channellist-wrap">*/}
              {/*  <GroupChannelList*/}
              {/*    selectedChannelUrl={channelUrl}*/}
              {/*    onChannelCreated={(channel) => {*/}
              {/*      onSelectChannel(channel.url)*/}
              {/*    }}*/}
              {/*    onChannelSelect={(channel) => {*/}
              {/*      onSelectChannel(channel?.url)*/}
              {/*    }}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className="sendbird-app__conversation-wrap">*/}
              {/*  <GroupChannel channelUrl={channelUrl!}/>*/}
              {/*</div>*/}
            </Flex>
          )}
        </ResizeableContent>
      )}
    </ThemedPage>
  );
};
